define('formkit/behavior/answer.save.behavior',['require','exports','module','underscore','marionette','backbone'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      Mn = require('marionette'),
      Backbone = require('backbone');

  //TODO: consider renaming this behavior BulkSaveAnswerBehavior to reflect that it requires a custom
  // Backbone.Collection with a 'save()' method to work
  var AnswerSaveBehavior = Mn.Behavior.extend({
    defaults: {
      form: null,
      answerCollection: null,

      // the amount of time that answering saving
      // should debounce before it actually saves
      saveDebounceTime: 1,
    },

    initialize: function() {
      this.changedAnswerModels = new Backbone.Collection([]);
      this.savedAnswerModels = new Backbone.Collection([]);
      this.form = this.getOption('form') || this.view.getOption('form');
      this.answerCollection = this.getOption('answerCollection') || this.view.getOption('answerCollection');
      if (!_.isFunction(this.answerCollection.save)) {
        throw new Error('The given answerCollection does not implement a save method.');
      }

      //TODO: add a "true" "immediate" arg to the debounce function or maybe better yet do away with it altogether
      // Also, saveAnswersDebounced (if we keep debouncing) should be a public method that can be unit tested more efficiently.
      //TODO: update the unit test to a better test when the above TODO is TODONE
      var saveAnswersDebounced = _.debounce(_.bind(this.saveAnswers, this), this.getOption('saveDebounceTime'));
      this.listenTo(this.form, 'end:edit:answer', function(model, options) {
        if (!this.saveTransactionStarted) {
          this.saveTransactionStarted = true;

          //TODO: if we're triggering the 'save:start' method, is it necessary to also call that method directly?
          this.triggerMethod('save:start', this);
          if (_.isFunction(this.getOption('onSaveStart'))) {
            this.getOption('onSaveStart').call(this);
          }
        }
        this.changedAnswerModels.push(options.answerModel);
        saveAnswersDebounced();
      });
      this.listenTo(this.form.getTemplateModel(), 'sync', function() {
        if (this.saveTransactionStarted && this.answerCollection.isEmpty()) {
          //Trigger the "end:answer:save" event for the currently saved answerModels, then reset the queue
          this.triggerAnswerSaveEvent(this.savedAnswerModels, 'end:answer:save');
          this.savedAnswerModels.reset();

          this.saveTransactionStarted = false;

          //TODO: if we're triggering the 'save:complete' method, is it necessary to also call that method directly?
          this.triggerMethod('save:complete', this);
          if (_.isFunction(this.getOption('onSaveComplete'))) {
            this.getOption('onSaveComplete').call(this);
          }
        }
      });
      this.listenTo(this.answerCollection, 'sync', function(collection, resp, options) {
        this.currentlySavingAnswers = false;

        //Maintain a reference to the saved models so we can trigger the "end:answer:save" event on them when the
        // templateObject syncs. We can't do it here because we may still have inbound data from a previous save, and
        // that's handled by the templateObject.
        this.savedAnswerModels.add(this.answerCollection.models);
        this.answerCollection.reset();
        this.saveAnswers();
        this.fetchTemplateState(options);
      });
    },

    fetchTemplateState: function(options) {
      if (!this.currentlySavingAnswers && this.changedAnswerModels.isEmpty()) {
        this.form.getTemplateModel().fetch(_.pick(options, 'requestTimestamp'));
      }
    },

    triggerAnswerSaveEvent: function(answerCollection, eventName) {
      answerCollection.each(function(model) {
        var answerValueCollection = model.get('data');

        if (answerValueCollection && typeof answerValueCollection.trigger === 'function') {
          answerValueCollection.trigger(eventName, answerValueCollection);
        }
      });
    },

    saveAnswers: function() {
      if (!this.currentlySavingAnswers && !this.changedAnswerModels.isEmpty()) {
        this.currentlySavingAnswers = true;
        this.answerCollection.add(this.changedAnswerModels.models);
        this.triggerAnswerSaveEvent(this.answerCollection, 'begin:answer:save');
        this.changedAnswerModels.reset();
        this.answerCollection.save();
      }
    },
  });

  module.exports = AnswerSaveBehavior;
});

